import React from "react";
import classnames from "classnames";
import * as _ from 'lodash';
import numeral from 'numeral';
import withStyles from "@material-ui/core/styles/withStyles";
// import Tooltip from "@material-ui/core/Tooltip";

// import Favorite from "@material-ui/icons/Favorite";

import GridContainer from "../../../components/Grid/GridContainer.jsx";
import GridItem from "../../../components/Grid/GridItem.jsx";
import Card from "../../../components/Card/Card.jsx";
// import CardHeader from "../../../components/Card/CardHeader.jsx";
import Button from "../../../components/CustomButtons/Button.jsx";

import styles from "../../../assets/jss/material-kit-pro-react/views/ecommerceSections/latestOffersStyle.jsx";

// import gucci from "../../../assets/img/bgFeatures.jpg";

const SectionRooms = props => {
    const { classes, accommodation, availableRooms, addToList, selectedRooms, filterButtonClicked } = props;

    return (
        <div>
            {filterButtonClicked ?
                availableRooms.length > 0 ?
                    <h3>Habitaciones disponibles:</h3>
                    :
                    <h4 className={classes.explanatoryNote}>No se encontraron habitaciones disponibles para las fechas o número de personas especificadas</h4>
                :
                <h4 className={classes.explanatoryNote}>Llena los campos de Entrada, Salida y Número de Personas para filtrar las habitaciones disponibles</h4>
            }

            {accommodation.rooms.map(room =>
                _.find(availableRooms, {_id: room._id})  ?
                    <Card className={classes.vecRoomContainer} key={room._id}>
                        <GridContainer>
                            <GridItem md={2} sm={2} className={classes.dashed}>
                                <h4 className={classnames(classes.vecRoomTitle, classes.noTopPadding)}>{room.name}</h4>
                            </GridItem>
                            <GridItem md={2} sm={2} className={classes.dashed}>
                                {!!room.beds.king_size ? <span className={classes.bedsDescription}>Camas King Size: {room.beds.king_size} <br/></span> : null}
                                {!!room.beds.queen_size ? <span className={classes.bedsDescription}>Camas Queen Size: {room.beds.queen_size} <br/></span> : null}
                                {!!room.beds.double_size ? <span className={classes.bedsDescription}>Camas Dobles: {room.beds.double_size} <br/></span> : null}
                                {!!room.beds.single_size ? <span className={classes.bedsDescription}>Camas Sencillas: {room.beds.single_size} <br/></span> : null}
                            </GridItem>
                            <GridItem md={2} sm={2} className={classes.dashed}>
                                <p className={classnames(classes.cardDescription, classes.noTopPadding)}>
                                    {room.description}
                                </p>
                            </GridItem>
                            <GridItem md={2} sm={2} className={classes.dashed}>
                                <p className={classes.noTopPadding}><strong>TV: </strong> {room.has_tv ? "Sí" : "No"}</p>
                                <p className={classes.noTopPadding}><strong>Baño privado: </strong> {room.has_bathroom ? "Sí" : "No"}</p>
                            </GridItem>
                            <GridItem md={2} sm={2} className={classes.dashed}>
                                <span className={classnames(classes.price, classes.priceNew)}>
                                    {(room.pricing.high_season === room.pricing.low_season) ?
                                        <h6 className={classes.noTopPadding}>COP$ {numeral(room.pricing.high_season).format('0,0')} por persona</h6> : null
                                    }
                                    {(room.pricing.high_season !== room.pricing.low_season) ?
                                        <div>
                                            <h6 className={classes.noTopPadding}>COP$ {numeral(room.pricing.high_season).format('0,0')} por persona, Temp. Alta</h6>
                                            <h6 className={classes.noTopPadding}>COP$ {numeral(room.pricing.low_season).format('0,0')} por persona, Temp. Baja</h6>
                                        </div>
                                        :
                                        null
                                    }
                                </span>
                            </GridItem>
                            <GridItem md={2} sm={2} className={classes.dashed}>
                                { _.find(selectedRooms, {_id: room._id}) ?
                                    <Button fullWidth={true} color="warning">
                                        Ya añadida
                                    </Button>
                                    :
                                    _.find(availableRooms, {_id: room._id})  ?
                                        <Button onClick={(e) => {addToList(room)}} fullWidth={true} color="success">
                                            Añadir a la Lista
                                        </Button>
                                        :
                                        null
                                }
                            </GridItem>
                        </GridContainer>
                    </Card>
                    :
                    null
            )}
        </div>
    );
};

export default withStyles(styles)(SectionRooms);



// WEBPACK FOOTER //
// ./src/views/AccommodationDetailPage/Sections/SectionRooms.jsx